const apiUrls = require('../../constants/apiUrls');

const accountOtherDetails = {
    key: 'accountOtherDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.ACCOUNT_OTHER_ATTR_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }
    ]
};

export default accountOtherDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/accountOtherDetails.js